import React from 'react';

import MaskedInput from 'react-text-mask';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    return (
        <MaskedInput
            {...other}
            required
            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
            placeholderChar={'\u2000'}
        />
    );
}

const CelPhoneField = ({ phone, inputHandle }) => {
    return (
        <FormControl fullWidth >
            <InputLabel htmlFor="txtCelular" shrink={phone != ''}>Celular *</InputLabel>
            <Input
                type="tel"
                name="phone"
                value={phone}
                onChange={inputHandle}
                inputComponent={TextMaskCustom}
            />
        </FormControl>
    );
}

export default React.memo(CelPhoneField);
